import React from 'react';
import LoadingAnima from '../assets/mad_loader_for_rr.gif';
import './LoadingIndicator.scss';
const LoadingIndicator = () => {
    return (
        <div className={'loading-indicator'}>
            <img src={LoadingAnima} alt={'Loading...'} />
        </div>
    )
};

export default LoadingIndicator;